import { render, staticRenderFns } from "./ModalModelosV2.vue?vue&type=template&id=cd8420b0"
import script from "./ModalModelosV2.vue?vue&type=script&lang=js"
export * from "./ModalModelosV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports